/**
 * @param callback
 * @example
 * <button onClick={handleStopPropagation((e) => console.log('clicked:', e?.target))}>Click me</button>
 */
export function handleStopPropagation<
  E extends Record<'stopPropagation', () => void>
>(callback?: (event: E) => void): (event: E) => void {
  return (event: E) => {
    event?.stopPropagation?.();
    callback?.(event);
  };
}

/**
 * @param callback
 * @example
 * <button onClick={handlePreventDefault((e) => console.log('clicked:', e?.target))}>Click me</button>
 */
export function handlePreventDefault<
  E extends Record<'preventDefault', () => void>
>(callback?: (event: E) => void): (event: E) => void {
  return (event: E) => {
    event?.preventDefault?.();
    callback?.(event);
  };
}
